export default {
  HOME_PAGE_URL: 'https://airdcpp-web.github.io',
  HELP_URL: 'https://airdcpp-web.github.io/docs/',
  ISSUE_TRACKER_URL: 'https://github.com/airdcpp-web/airdcpp-webclient/issues',
  DBIP_URL: 'https://db-ip.com',

  SPEEDTEST_URL: 'https://www.speedtest.net',
  PORTCHECK_URL: 'https://www.yougetsignal.com/tools/open-ports/',
  CONNECTIVITY_HELP_URL: 'https://dcplusplus.sourceforge.net/webhelp/faq_connection.html',

  VARIABLE_HELP_URL: 'https://airdcpp.net/docs/usage/setting-variables.html',

  DEFAULT_ENGINE_URL: 'https://www.nodejs.org',
  DEV_HUB_URL: 'adcs://web-dev.airdcpp.net:1511',

  TRANSLATOR_HELP: 'https://airdcpp-web.github.io/docs/advanced/translations.html',
};
